import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Flex, Image, P, ResponsiveSVG } from 'ui/acro'
import { CardTitle } from 'components_v1/SchemaSectionRenderer/common/styles'
import { AlomovesIconSVG } from 'images/latest'
import clockSVG from '../../../../../../app/assets/images/clock.svg'
import playSVG from '../../../../../../app/assets/images/play.svg'
import { LIKED_ITEMS_SLUG } from 'components_v1/common'

const CountAndDuration = styled(Flex)`
  gap: 4px;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px; /* 116.667% */
  letter-spacing: 0.84px;
  text-transform: uppercase;
`
const AuthorName = styled('p')`
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  letter-spacing: 0.308px;
  text-transform: capitalize;
`

const PlaylistCardMobile = ({
  id,
  uuid,
  coverPhoto,
  duration,
  classCount,
  title,
  author,
  onClickHandler
}) => {
  let image
  if (typeof coverPhoto !== 'undefined') {
    image = coverPhoto
  }

  return (
    <Flex gap='8px' as='a' href={`/playlists/${uuid}?source=mypractice`}>
      {image ? (
        <Image
          src={image}
          objectFit='cover'
          position='absolute'
          top='0'
          left='0'
          style={{ aspectRatio: '16/9', width: '30%' }}
        />
      ) : (
        <ResponsiveSVG
          SVG={AlomovesIconSVG}
          className='no-thumbnail'
          style={{ aspectRatio: '16/9', width: '30%' }}
        />
      )}
      <Flex flex='1' flexDirection='column' style={{ overflow: 'hidden' }}>
        <Flex justifyContent='space-between' alignItems='baseline'>
          {title && (
            <CardTitle
              id='PlaylistTitle'
              as='div'
              paddingBottom='6px'
              style={{
                fontWeight: '600',
                width: '80%',
                textTransform: 'capitalize',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {title}
            </CardTitle>
          )}
          {uuid !== LIKED_ITEMS_SLUG && (
            <P
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onClickHandler()
              }}
            >
              • • •
            </P>
          )}
        </Flex>
        <Flex flexDirection='column' flex='1' justifyContent='space-between'>
          {author.firstName && <AuthorName>{author.firstName}</AuthorName>}
          <Flex gap='16px'>
            {uuid !== LIKED_ITEMS_SLUG && typeof classCount === 'number' && (
              <CountAndDuration>
                <ResponsiveSVG SVG={playSVG} width='14px' height='14px' />
                {`${classCount} Class${classCount <= 1 ? '' : 'es'}`}
              </CountAndDuration>
            )}
            {duration && (
              <CountAndDuration>
                <ResponsiveSVG SVG={clockSVG} width='14px' height='14px' />
                {duration}
              </CountAndDuration>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

PlaylistCardMobile.propTypes = {
  duration: PropTypes.string,
  id: PropTypes.number,
  classCount: PropTypes.number,
  title: PropTypes.string.isRequired,
  coverPhoto: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired
}

export default PlaylistCardMobile
